module.exports = __webpack_public_path__ + "static/images/activity_over_86f62919.png";